import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError } from '@components/common/AlertToast';

function* newFilterNextPageLancamentosBanco(action) {
  try {
    yield put({ type: NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING });

    const { page, rows } = action;
    const { contaBancoId, dataInicio, dataFim, tipoMovimento, historico } = action.args || {};

    const response = yield call(
      conciliacaoBancariaService.buscarLancamentosBancoPendentes,
      contaBancoId,
      dataInicio,
      dataFim,
      page,
      rows || 10,
      tipoMovimento,
      historico
    );

    // A API pode retornar os dados em response.data ou diretamente em response
    const responseData = response.data || response;

    yield put({
      type: NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
      response: responseData,
      rows: rows || 10,
      page,
      args: { contaBancoId, dataInicio, dataFim, tipoMovimento, historico }
    });

  } catch (error) {
    yield put({
      type: NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar próxima página'
    });

    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar próxima página';
    AlertError(errorMessage);
  }
}

export default function* watchNewFilterNextPageLancamentosBanco() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO, newFilterNextPageLancamentosBanco);
}
